import { render, staticRenderFns } from "./blessingBagDetail.vue?vue&type=template&id=387ff722&scoped=true&"
import script from "./blessingBagDetail.ts?vue&type=script&lang=ts&"
export * from "./blessingBagDetail.ts?vue&type=script&lang=ts&"
import style0 from "./blessingBagDetail.vue?vue&type=style&index=0&id=387ff722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ff722",
  null
  
)

export default component.exports